<template>
  <LoginLayout class="reset">
    <template v-if="complete">
      <h1 class="title">パスワードを変更しました</h1>
      <p class="discription">新しいパスワードを使ってログインしてください。</p>
      <Button :small="isSP" primary @click="onClose">閉じる</Button>
    </template>
    <template v-else>
      <h1 class="title">新しいパスワードを入力してください</h1>
      <div class="form-box">
        <span class="form-name">新しいパスワード</span>
        <AdornmentsInput
          :type="passwordType"
          :prefixIcon="LockIcon"
          maxlength="16"
          placeholder="パスワード"
          autocomplete="nope"
          v-model="password"
          @keypress.enter="onSubmit"
          @focus="typeChange"
        />
      </div>
      <div class="form-box validation">
        <div class="validation-item">
          <CheckIcon :class="['check', { 'is-ok': isOver }]" circle width="20" height="20" />
          <span>6文字以上16文字以下</span>
        </div>
        <div class="validation-item">
          <CheckIcon :class="['check', { 'is-ok': isMixed }]" circle width="20" height="20" />
          <span>英字と数字を含む</span>
        </div>
      </div>
      <div class="form-box">
        <span class="form-name">パスワード再入力</span>
        <AdornmentsInput
          :type="passwordType"
          :prefixIcon="LockIcon"
          maxlength="16"
          placeholder="パスワード"
          autocomplete="nope"
          v-model="reinput"
          @keypress.enter="onSubmit"
          @focus="typeChange"
        />
      </div>
      <Button :small="isSP" primary :disabled="isDisabled" @click="onSubmit">パスワード変更</Button>
    </template>
    <LoadingIndicator v-if="busy" />
  </LoginLayout>
</template>

<script>
import { mapState } from 'vuex'
import LoginLayout from '@/components/templates/LoginLayout'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import Button from '@/components/atoms/Button'
import AdornmentsInput from '@/components/molecules/AdornmentsInput'
import MailInverseIcon from '@/components/icons/mailInverse'
import LockIcon from '@/components/icons/lock'
import CheckIcon from '@/components/icons/CheckIcon'

export default {
  name: 'Init',
  components: {
    LoginLayout,
    LoadingIndicator,
    Button,
    AdornmentsInput,
    CheckIcon,
  },
  data() {
    return {
      password: '',
      reinput: '',
      passwordType: 'text',
      complete: false,
      MailInverseIcon,
      LockIcon,
    }
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      busy: state => state.users.current.busy,
    }),
    isDirty() {
      return this.password !== '' && this.reinput !== ''
    },
    isOver() {
      return this.password.length >= 6 && this.password.length <= 16
    },
    isMixed() {
      return this.password !== '' && /([0-9][a-zA-Z]|[a-zA-Z][0-9])/.test(this.password)
    },
    isDisabled() {
      return !this.isDirty || !this.isOver || !this.isMixed
    },
  },
  methods: {
    async onSubmit() {
      if (
        await this.$store.dispatch('users/current/changePassword', {
          token: this.$route.query.token,
          newPassword: this.password,
          confirmPassword: this.reinput,
        })
      ) {
        this.complete = true
      } else {
        this.password = ''
        this.reinput = ''
      }
    },
    onClose() {
      window.open('about:blank', '_self').close()
    },
    typeChange() {
      this.passwordType = 'password'
    },
  },
}
</script>

<style lang="postcss" scoped>
.title {
  font-size: 21px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 48px;
  text-align: center;
}

.discription {
  text-align: center;
}

.form-box {
  align-items: center;
  align-self: center;
  display: grid;
  grid-template-columns: 1fr 256px;
  width: 384px;

  & + & {
    margin-top: 24px;
  }

  &.validation {
    grid-template-columns: 256px;
    justify-content: end;
    margin-top: 10px;
  }
}

.form-name {
  color: var(--very-dark-gray-2);
}

.validation-item {
  align-items: center;
  display: flex;
  padding: 0 18px;
}

.check {
  fill: var(--light-gray);
  margin-right: 10px;

  &.is-ok {
    fill: #1abc9c;

    & + span {
      font-weight: 600;
    }
  }
}

.responsive {
  @media screen and (max-width: 559px) {
    .title {
      font-size: 16px;
      margin-bottom: 36px;
    }

    .discription {
      font-size: 15px;
      text-align: center;
    }

    .form-box {
      grid-auto-flow: row;
      grid-gap: 10px;
      grid-template-columns: none;
      width: 100%;

      &.validation {
        font-size: 15px;
        grid-auto-flow: row;
        grid-gap: 10px;
        grid-template-columns: none;
        justify-content: start;

        & span {
          line-height: 1;
        }
      }
    }

    .form-name {
      font-size: 13px;
      line-height: 1;
    }
  }
}
</style>
